import {
	Collapse,
	Divider,
	Drawer,
	Icon,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
} from "../../common/MaterialComponent";
import { Link, BrowserRouter as Router } from "react-router-dom";
import React, { useEffect } from "react";

import Emitter from "../../common/emitter";
import { RouterViewOkta } from "../Routing/RouterViewOkta";
import { SessionDetail } from "../../common/interfaces";
import Shared from "../../common/shared";
import { UserProfile } from "../UserProfile/UserProfile";
import clsx from "clsx";
import styles from "./NavigationDrawer.style";
import { useGetComponentStringsContext } from "../../hooks/useGetComponentStrings";
import { useSessionDetailContext } from "../../hooks/useSessionDetail";
import { RouterViewMsal } from "../Routing/RouterViewMsal";

interface NavigationDrawerProps {
	openMenu: boolean;
	toggleDrawer: (open: boolean, event: any) => void;
}

export const NavigationDrawer: React.FC<NavigationDrawerProps> = ({
	openMenu,
	toggleDrawer,
}) => {
	const classes = styles();
	const strings = useGetComponentStringsContext().NavigationDrawer;
	const contextSessionDetail = useSessionDetailContext().sessionDetail;
	const sharedStrings = useGetComponentStringsContext().Shared;

	const [openSubMenu, setOpen] = React.useState(false);
	const onCollapseSubMenu = () => {
		setOpen(!openSubMenu);
	};
	const onListItemClick = (event: any) => {
		toggleDrawer(false, event);
		setOpen(false);
	};
	const [sessionDetail, setSessionDetail] = React.useState<SessionDetail>(
		contextSessionDetail
	);

	const isClientIFRC = process.env.REACT_APP_CLIENT_NAME === "IFRC";

	useEffect(() => {
		setSessionDetail(contextSessionDetail);
	}, [contextSessionDetail]);

	const logOut = (event: any) => {
		Emitter.emit("logout", {});
		onListItemClick(event);
	};

	return (
		<div className="navigationDrawer">
			<Router>
				<Drawer
					anchor="left"
					open={openMenu}
					onClose={(event) => toggleDrawer(false, event)}
				>
					<div className={classes.drawerHeader}>
						{sessionDetail && sessionDetail.userInfo ? (
							<UserProfile />
						) : (
							<img
								src={
									isClientIFRC
										? `/images/${sharedStrings.ifrcLogoUrl}`
										: `/images/${sharedStrings.nrcLogoUrl}`
								}
								alt="Logo"
								className={classes.imgLogo}
							></img>
						)}
					</div>
					<Divider />
					<List className={classes.drawerWidth} role="presentation">
						<Link to="/home" className={classes.navigationLink}>
							<ListItem
								button
								onClick={onListItemClick}
								onKeyDown={onListItemClick}
							>
								<ListItemIcon className={classes.listItemIcon}>
									<Icon color="primary">home</Icon>
								</ListItemIcon>
								<ListItemText primary={strings.homePageMenu} />
							</ListItem>
						</Link>
						<Link to="/templateLibraryView" className={classes.navigationLink}>
							<ListItem
								button
								onClick={onListItemClick}
								onKeyDown={onListItemClick}
							>
								<ListItemIcon className={classes.listItemIcon}>
									<Icon color="primary">view_column</Icon>
								</ListItemIcon>
								<ListItemText primary={strings.templateLibraryViewPageMenu} />
							</ListItem>
						</Link>
						{Shared.isUserGlobalAdminOrCountryAdmin() && (
							<>
								<ListItem button onClick={onCollapseSubMenu}>
									<ListItemIcon className={classes.listItemIcon}>
										<Icon color="primary">person</Icon>
									</ListItemIcon>
									<ListItemText primary={strings.adminMenu} />
								</ListItem>
								<Collapse in={openSubMenu} timeout="auto" unmountOnExit>
									<Link to="/projectList" className={classes.navigationLink}>
										<ListItem
											onClick={(event) => toggleDrawer(false, event)}
											onKeyDown={(event) => toggleDrawer(false, event)}
											button
											className={classes.nested}
										>
											<ListItemIcon className={classes.listItemIcon}>
												<Icon color="primary">list</Icon>
											</ListItemIcon>
											<ListItemText primary={strings.projectMenu} />
										</ListItem>
									</Link>
									<Link to="/variablesList" className={classes.navigationLink}>
										<ListItem
											onClick={(event) => toggleDrawer(false, event)}
											onKeyDown={(event) => toggleDrawer(false, event)}
											button
											className={classes.nested}
										>
											<ListItemIcon className={classes.listItemIcon}>
												<Icon color="primary">list</Icon>
											</ListItemIcon>
											<ListItemText primary={strings.variablesMenu} />
										</ListItem>
									</Link>
									<Link
										to="/userPermissionsList"
										className={classes.navigationLink}
									>
										<ListItem
											onClick={(event) => toggleDrawer(false, event)}
											onKeyDown={(event) => toggleDrawer(false, event)}
											button
											className={classes.nested}
										>
											<ListItemIcon className={classes.listItemIcon}>
												<Icon color="primary">list</Icon>
											</ListItemIcon>
											<ListItemText primary={strings.userPermissionsMenu} />
										</ListItem>
									</Link>
								</Collapse>
							</>
						)}
						{Shared.canApproveOrRejectTemplate() && (
							<Link
								to="/templatesAwaitingApproval"
								className={classes.navigationLink}
							>
								<ListItem
									button
									onClick={onListItemClick}
									onKeyDown={onListItemClick}
								>
									<ListItemIcon className={classes.listItemIcon}>
										<Icon color="primary">list</Icon>
									</ListItemIcon>
									<ListItemText primary={strings.awaitingApprovalMenu} />
								</ListItem>
							</Link>
						)}
						<Link to="/templateList" className={classes.navigationLink}>
							<ListItem
								button
								onClick={onListItemClick}
								onKeyDown={onListItemClick}
							>
								<ListItemIcon className={classes.listItemIcon}>
									<Icon color="primary">list</Icon>
								</ListItemIcon>
								<ListItemText primary={strings.templateList} />
							</ListItem>
						</Link>
						<Link to="/scheduledTemplates" className={classes.navigationLink}>
							<ListItem
								onClick={(event) => toggleDrawer(false, event)}
								onKeyDown={(event) => toggleDrawer(false, event)}
								button
							>
								<ListItemIcon className={classes.listItemIcon}>
									<Icon color="primary">list</Icon>
								</ListItemIcon>
								<ListItemText primary={strings.scheduledTemplatesMenu} />
							</ListItem>
						</Link>
						<Divider />
						{sessionDetail && sessionDetail.accessToken && (
							<ListItem button onClick={logOut}>
								<ListItemIcon className={classes.listItemIcon}>
									<Icon color="primary">logout</Icon>
								</ListItemIcon>
								<ListItemText primary="Logout" />
							</ListItem>
						)}
					</List>
				</Drawer>
				<div className={classes.drawerHeader} />
				{!Shared.getAccessToken() && (
					<div className={classes.loginInfoContainer}>
						<div className={classes.loginInfo}>{strings.loginInfoMessage}</div>
					</div>
				)}
				{!isClientIFRC ? (
					<main className={clsx(classes.content)}>
						<RouterViewOkta />
					</main>
				) : (
					<main className={clsx(classes.content)}>
						<RouterViewMsal />
					</main>
				)}
			</Router>
		</div>
	);
};
